"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROGRAM_TYPE_MAPPER = void 0;
const enums_service_1 = require("../../../services/enums.service");
exports.PROGRAM_TYPE_MAPPER = {
    [enums_service_1.ProgramTypesEnum.CLASS]: enums_service_1.ProgramTypeNameEnum.CLASS,
    [enums_service_1.ProgramTypesEnum.CLINIC]: enums_service_1.ProgramTypeNameEnum.CLINIC,
    [enums_service_1.ProgramTypesEnum.CAMP]: enums_service_1.ProgramTypeNameEnum.CAMP,
    [enums_service_1.ProgramTypesEnum.CLUB_TEAM]: enums_service_1.ProgramTypeNameEnum.CLUB_TEAM,
    [enums_service_1.ProgramTypesEnum.LESSON]: enums_service_1.ProgramTypeNameEnum.LESSON,
    [enums_service_1.ProgramTypesEnum.TOURNAMENT]: enums_service_1.ProgramTypeNameEnum.TOURNAMENT,
    [enums_service_1.ProgramTypesEnum.LEAGUE]: enums_service_1.ProgramTypeNameEnum.LEAGUE,
};
//# sourceMappingURL=program.consts.js.map